// src/components/PrayerButtonGrid.js
import React from 'react';
import { Button, Row, Col } from 'react-bootstrap';



const categoryIcons = {
  daily: "📅",
  christian: "📖",
  catholic: "🕯️",
  father: "👨",
  mother: "👩",
  wife_prayer: "💍",
  husband_prayer: "🤵",
  son_prayer: "👦",
  daughter_prayer: "👧",
  brother_prayer: "👨‍👦",
  sister_prayer: "👭",
  friend_prayer: "🤝",
  health_prayer: "❤️‍🩹",
  finances_prayer: "💰",
  world_prayer: "🌍",
  extended_family_prayer: "👨‍👩‍👧‍👦",
  boyfriend: "💙",
  girlfriend: "💖",
  wisdom_prayer: "🦉",
  peace_prayer: "🕊️",
  patience_prayer: "⏳",
  gratitude_prayer: "🙏",
  faith_prayer: "✝️",
  forgiveness_prayer: "🤍",
  guidance_prayer: "🧭",
  strength_prayer: "💪",
  anxiety_prayer: "😟",
  purpose_prayer: "🌟",
  dog_prayer: "🐶",
  cat_prayer: "🐱"
};


function PrayerButtonGrid({ categories, onSelect, labels = {} }) {
  return (
    <Row className="g-3">
      {categories.map((category) => (
        <Col key={category} xs={6} sm={6} md={4} lg={3}>
          <Button
            variant="primary"
            className="w-100 glass-button bg-transparent border-0 rounded-pill text-capitalize d-flex align-items-center justify-content-center"
            onClick={() => onSelect(category)}
          >
            <span style={{ fontSize: "1.25rem", marginRight: "0.5rem" }}>
              {categoryIcons[category] || "🙏"}
            </span>
            {labels[category] ||
              category
                .replace('_prayer', '')
                .replace(/_/g, ' ')
                .replace(/\b\w/g, (l) => l.toUpperCase())}
          </Button>
        </Col>
      ))}
    </Row>
  );
}

export default PrayerButtonGrid;

